var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 8C16.6667 8 13.6667 2.5 8.66675 2.5C3.66675 2.5 0.666748 8 0.666748 8C0.666748 8 3.66675 13.5 8.66675 13.5C13.6667 13.5 16.6667 8 16.6667 8ZM1.83945 8C1.89637 7.91321 1.96129 7.81677 2.03402 7.71242C2.36891 7.23193 2.86306 6.5929 3.49885 5.95711C4.78778 4.66818 6.54737 3.5 8.66675 3.5C10.7861 3.5 12.5457 4.66818 13.8346 5.95711C14.4704 6.5929 14.9646 7.23193 15.2995 7.71242C15.3722 7.81677 15.4371 7.91321 15.494 8C15.4371 8.08679 15.3722 8.18323 15.2995 8.28758C14.9646 8.76807 14.4704 9.4071 13.8346 10.0429C12.5457 11.3318 10.7861 12.5 8.66675 12.5C6.54737 12.5 4.78778 11.3318 3.49885 10.0429C2.86306 9.4071 2.36891 8.76807 2.03402 8.28758C1.96129 8.18323 1.89637 8.08679 1.83945 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 5.5C7.28604 5.5 6.16675 6.61929 6.16675 8C6.16675 9.38071 7.28604 10.5 8.66675 10.5C10.0475 10.5 11.1667 9.38071 11.1667 8C11.1667 6.61929 10.0475 5.5 8.66675 5.5ZM5.16675 8C5.16675 6.067 6.73375 4.5 8.66675 4.5C10.5997 4.5 12.1667 6.067 12.1667 8C12.1667 9.933 10.5997 11.5 8.66675 11.5C6.73375 11.5 5.16675 9.933 5.16675 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.9ff901194d9888124d977c95c6ceb205.svg";
export { ForwardRef as ReactComponent };